module.exports = __webpack_public_path__ + "static/media/bw.2f0ecfbb.svg";